var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 14.1666,
    width: 9.19999,
    height: 11,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12.1666,
    width: 9.19999,
    height: 11,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9805,
    y: 12.1669,
    width: 9.19999,
    height: 11,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.98047,
    y: 8.16693,
    width: 9.19999,
    height: 11,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5254,
    y: 2.16711,
    width: 9.19999,
    height: 13.4847,
    transform: "rotate(51.2793 11.5254 2.16711)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7.77582,
    width: 9.19999,
    height: 14.8765,
    transform: "rotate(-45.9222 5 7.77582)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1.98047,
    y: 12.1669,
    width: 9.19999,
    height: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55555 25.1676H20.4444C21.1222 25.1676 21.7722 24.9042 22.2515 24.4353C22.7307 23.9665 23 23.3306 23 22.6676V11.4176C23.001 11.253 22.9687 11.09 22.9051 10.9377C22.8415 10.7854 22.7478 10.6469 22.6294 10.5301L12.4072 0.530056C12.1678 0.297242 11.8439 0.166565 11.5064 0.166565C11.1688 0.166565 10.845 0.297242 10.6055 0.530056L0.383333 10.5301C0.262598 10.6458 0.166548 10.7839 0.100747 10.9362C0.0349455 11.0886 0.000701819 11.2522 0 11.4176V22.6676C0 23.3306 0.269245 23.9665 0.748504 24.4353C1.22776 24.9042 1.87778 25.1676 2.55555 25.1676ZM8.94444 22.6676V16.4176H14.0555V22.6676H8.94444ZM2.55555 11.9301L11.5 3.18006L20.4444 11.9301V22.6676H16.6111V16.4176C16.6111 15.7545 16.3419 15.1186 15.8626 14.6498C15.3833 14.1809 14.7333 13.9176 14.0555 13.9176H8.94444C8.26666 13.9176 7.61665 14.1809 7.13739 14.6498C6.65813 15.1186 6.38888 15.7545 6.38888 16.4176V22.6676H2.55555V11.9301Z",
    fill: "#5A2D00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.dd1ca9cd3d8e175a2e1d41734c75f1a4.svg";
export { ForwardRef as ReactComponent };